import React from 'react';
import { Tooltip, Space, Card, Button } from 'antd';

const text= "Lorem Ipsum"

function Tooltips() {
  return (
    <Card title="Tooltips">
      <Space>
      <Tooltip placement="left" title={text}>
          <Button>Left</Button>
        </Tooltip>
        <Tooltip placement="top" title={text}>
          <Button>Top</Button>
        </Tooltip>
        <Tooltip placement="right" title={text}>
          <Button>Right</Button>
        </Tooltip>
      </Space>
    </Card>
  )
}

export default Tooltips;
